// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2QsL6{position:relative}._2QsL6 label input{padding-right:35px}._1ILVB{top:12px;right:17px;cursor:pointer;position:absolute!important}", ""]);
// Exports
module.exports = exports;
